import { render, staticRenderFns } from "./service-list.vue?vue&type=template&id=ca4458de&scoped=true"
import script from "./service-list.vue?vue&type=script&lang=js"
export * from "./service-list.vue?vue&type=script&lang=js"
import style0 from "./service-list.vue?vue&type=style&index=0&id=ca4458de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4458de",
  null
  
)

export default component.exports